import React from "react";
import "./skeleton.css";

/**
 * SkeletonProfileHeader — Skeleton for the Profil page header.
 * Mirrors the banner + avatar + name/email card layout.
 */
export default function SkeletonProfileHeader() {
    return (
        <div role="presentation" aria-busy="true" aria-label="Chargement du profil">
            {/* Profile Card Shell */}
            <div
                className="relative mb-8 overflow-hidden rounded-3xl border border-border bg-card"
                style={{ boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.15)" }}
            >
                {/* Banner */}
                <div className="skeleton-bone skeleton-profile-banner" style={{ borderRadius: 0 }} />

                {/* Content area */}
                <div className="px-8 pb-8">
                    <div className="flex flex-col md:flex-row items-center md:items-start gap-6">
                        {/* Avatar circle */}
                        <div
                            className="skeleton-bone skeleton-circle skeleton-profile-avatar skeleton-stagger-1"
                        />

                        {/* Name + Email */}
                        <div className="text-center md:text-left pb-2 flex-1 w-full md:w-auto md:mt-24">
                            <div className="flex items-center justify-center md:justify-start mb-2">
                                <div className="skeleton-bone skeleton-profile-name skeleton-stagger-2" />
                            </div>
                            <div className="flex items-center justify-center md:justify-start">
                                <div className="skeleton-bone skeleton-profile-email skeleton-stagger-3" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Account Management Skeleton */}
            <div className="space-y-4">
                <div className="skeleton-bone skeleton-rounded-xl" style={{ height: "3rem", width: "12rem" }} />
                <div
                    className="skeleton-bone skeleton-rounded-xl skeleton-stagger-2"
                    style={{ height: "8rem", width: "100%" }}
                />
            </div>
        </div>
    );
}
